import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import kajLogo from "../../assets/images/kajlogo.png";
import "./AppLoader.css";

const LOADER_MS = 880;

const AppLoader = () => {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    setVisible(true);
    document.body.style.overflow = "hidden";

    const timer = window.setTimeout(() => {
      setVisible(false);
      document.body.style.overflow = "";
    }, LOADER_MS);

    return () => {
      window.clearTimeout(timer);
      document.body.style.overflow = "";
    };
  }, [pathname]);

  if (!visible) return null;

  return (
    <div className="app-loader" role="status" aria-label="Loading">
      <img src={kajLogo} alt="" className="app-loader-logo" />
    </div>
  );
};

export default AppLoader;
